module.exports = function isUndefined(obj){return (typeof obj === 'undefined');}


/*****************
 ** WEBPACK FOOTER
 ** ./lib/isUndefined.js
 ** module id = 28
 ** module chunks = 0
 **/